<script></script>

<span><slot /></span>